import { useQuery } from "@tanstack/react-query";
import { getLeatContactAttributes } from "../../api/bLeatApi";

export const useGetLeatContactAttributes = (organisationId, enabled = true) => {
  return useQuery({
    queryKey: ["leat-contact-attributes", organisationId],
    queryFn: () => getLeatContactAttributes(organisationId),
    enabled: !!organisationId && enabled,
    staleTime: 5 * 60 * 1000,
  });
};
